(() => {
  'use strict';

  /* ==================================================
    予約販売（SKU単位）の案内表示をバリアント切替に追従させる
  ===================================================*/

  /*
    c_product-preorder.js

    テーマ Focal の <product-rerender allow-partial-rerender> は、差し替え対象の
    data-block-type をテーマ既定のもの（variant-picker / buy-buttons など）に
    限定している。カスタムブロックはその一覧に載らないため差し替えられない。
    そこで <c-product-preorder> 自身が product:rerender を受け取り、
    サーバー描画済みの新しいHTMLへ自分を差し替える。

    product:rerender は variant:changed と同じタイミング（セクション再取得の完了後）に
    発火するため、カートに追加ボタンの文言切替と表示がずれない。

    仕様: docs/SPECS/product-preorder-variant.md
  */

  if (window.customElements.get('c-product-preorder')) return;

  class ProductPreorder extends HTMLElement {
    constructor() {
      super();
      this.onRerender = this.onRerender.bind(this);
    }

    connectedCallback() {
      this.form = document.forms[this.getAttribute('form-id')];
      this.form?.addEventListener('product:rerender', this.onRerender);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('product:rerender', this.onRerender);
      this.form = null;
    }

    onRerender(event) {
      /*  商品自体が切り替わるときは親の <product-rerender> が全体を差し替えるため何もしない  */
      if (event.detail.productChange) return;

      const fragment = event.detail.htmlFragment;
      if (!fragment) return;

      /*
        再取得したHTMLには本体用とクイックビュー用の同じブロックが並ぶため form-id で絞り込む。
        クイックビュー側は <template> の中にあり querySelector では拾わないが、
        あちらは親の <product-rerender> が全体を差し替えるため取りこぼしにはならない
      */
      const selector = `c-product-preorder[form-id="${CSS.escape(this.getAttribute('form-id') || '')}"][data-block-id="${CSS.escape(this.dataset.blockId || '')}"]`;
      const next = fragment.querySelector(selector);
      if (next) this.replaceWith(next);
    }
  }

  window.customElements.define('c-product-preorder', ProductPreorder);
})();
